import { Flex, Text, Title } from "@mantine/core";
import { EstimateLineProps, TariffDetailNode } from "../types/types";
import { FormattedMessage, FormattedNumber, useIntl } from "react-intl";
import { i18n } from "../i18n/langType";

//TODO: Combine this and other expanded price display item into single component
export function ExpandedPriceDisplayItemMinute({
  tariffNode,
  currency,
}: {
  tariffNode: TariffDetailNode;
  currency: string;
}) {
  const intl = useIntl();
    if (!tariffNode) {
        return (
            <div>
                <Text>Blocking fee information not available</Text>
            </div>
        );
    }

  const prices = tariffNode.prices || [];
    const freePrice = prices.find(p => p.price === 0);
    const paidPrice = prices.find(p => p.price != null && p.price > 0);
    
    if (!freePrice || !paidPrice) {
        return (
            <div>
                <Text>Fee information not available</Text>
            </div>
        );
    }

    const thresholdMinutes = paidPrice.min || 0;
    return (
        <div>
            <Flex justify="space-between" w="100%" mb="sm">
                <Text>
                    {intl.formatMessage(
                        { id: i18n.priceUntil },
                        {
                            value: intl.formatNumber(Number(thresholdMinutes), {
                                style: "unit",
                                unit: "minute",
                            }),
                        }
                    )}
                </Text>
                <Text fw="bold">
                    {intl.formatNumber(Number(freePrice.price), {
                        style: "currency",
                        currency: currency,
                    })}
                    /{intl.formatMessage({ id: i18n.minuteAbbr })}
                </Text>
            </Flex>
            <Flex justify="space-between" w="100%" mb="md">
                <Text>
                    <FormattedMessage
                        id={i18n.priceAfter}
                        values={{
                            value: intl.formatNumber(Number(thresholdMinutes), {
                                style: "unit",
                                unit: "minute",
                            }),
                        }}
                    />
                </Text>
                <Text fw="bold">
                    <FormattedNumber
                        style="currency"
                        currency={currency}
                        value={Number(paidPrice.price)}
                    />
                    /{intl.formatMessage({ id: i18n.minuteAbbr })}
                </Text>
            </Flex>
        </div>
    );
}
